// TODO refactore or remove it
export function submitFormStatus() {
    $('#status').on('change', function(){
        $('form').submit();
    })
}